import { useTheme } from "../../../components/hooks/useTheme";
import { useState } from "react";
import { MaintenanceList } from "./MaintenanceList";

const filterItems = [
  {
    id: 0,
    label: "Maintenance Type Name",
  },
  {
    id: 1,
    label: "Vehicle Name",
  },
  {
    id: 2,
    label: "Maintenance Status Name",
  },
  {
    id: 3,
    label: "Location Name",
  },
]

export const Maintenance = () => {
  const { themeStyles } = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchValue, setSearchValue] = useState<string>("");
  const [maintenanceFilterValue, setMaintenanceFilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
        </div>

        <div>
          <MaintenanceList
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            maintenanceFilterValue={maintenanceFilterValue}
            setMaintenanceFilterValue={setMaintenanceFilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  )
}